import React, { Fragment, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import ErrorPage from "../ErrorPage/ErrorPage";
import { getEntity } from "../../data/companies";

// ============================================================
// Reusable page — har Corporate Company / Strategic Program ki
// site isi template se render hoti hai (data: src/data/companies.ts)
// ============================================================
const CompanyPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const entity = getEntity(slug || "");

  useEffect(() => {
    if (entity) {
      document.title = `${entity.name} — KOT Enterprises`;
    }
  }, [entity]);

  if (!entity) return <ErrorPage />;

  return (
    <Fragment>
      <div className="about-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle
              pageTitle={entity.name}
              pagesub={
                entity.type === "company"
                  ? "Corporate Companies"
                  : "Strategic Programs"
              }
            />

            {/* ===== Intro ===== */}
            <section className="about pt-100 pb-60">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-10">
                    <div className="sec-title sec-title-center text-center mb-30">
                      <span className="sub-title mb-10">{entity.tagline}</span>
                      <h2 className="title title-line_height">
                        {entity.headline}
                      </h2>
                      <p className="content mt-20">{entity.summary}</p>
                    </div>
                  </div>
                </div>

                {/* Purpose bullets */}
                <div className="row justify-content-center mt-20">
                  {entity.purpose.map((point, i) => (
                    <div className="col-lg-6 mt-20" key={i}>
                      <div className="xb-feature-item h-100">
                        <div className="xb-item--inner xb-border h-100">
                          <span
                            className="xb-item--icon"
                            style={{ fontSize: 22, color: "var(--color-primary)" }}
                          >
                            <i className="fa-solid fa-circle-check"></i>
                          </span>
                          <div className="xb-item--holder">
                            <p className="xb-item--content">{point}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* ===== Services / Pillars ===== */}
            <section className="feature pt-60 pb-80">
              <div className="container">
                <div className="sec-title sec-title-center text-center mb-40">
                  <span className="sub-title mb-15">
                    {entity.type === "company"
                      ? "What We Deliver"
                      : "Our Pillars"}
                  </span>
                  <h2 className="title">
                    {entity.type === "company"
                      ? "Key service areas"
                      : "How the program works"}
                  </h2>
                </div>

                <div className="row mt-none-30 justify-content-center">
                  {entity.services.map((service, i) => {
                    // 4 cards → 2x2 (col-lg-6); 3/6/9 → 3-col (col-lg-4); baqi → 2-col
                    const colClass =
                      entity.services.length === 4
                        ? "col-lg-6 col-md-6"
                        : entity.services.length % 3 === 0
                        ? "col-lg-4 col-md-6"
                        : "col-lg-6 col-md-6";
                    return (
                      <div className={`${colClass} mt-30`} key={i}>
                        <div className="xb-feature-item h-100">
                          <div className="xb-item--inner xb-border xb-prog-card h-100">
                            <span className="xb-prog-card--num">
                              {String(i + 1).padStart(2, "0")}
                            </span>
                            <div className="xb-item--holder">
                              <h2 className="xb-item--title">{service.title}</h2>
                              <p className="xb-item--content">{service.desc}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </section>

            {/* ===== Ecosystem Role + CTA ===== */}
            <section className="contact-section pt-80 pb-120">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-10">
                    <div className="xb-contact-form xb-border text-center">
                      <div className="sec-title sec-title-center text-center mb-20">
                        <span className="sub-title mb-15">
                          Part of the KOT Ecosystem
                        </span>
                        <p className="content">{entity.ecosystemRole}</p>
                      </div>
                      <div className="mt-30">
                        <Link className="thm-btn" to="/#contact">
                          Work with {entity.name}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default CompanyPage;
